




















import mixins from 'vue-typed-mixins';
import { validatorInArray } from '@/utils/string';
import E2EMixin from '@/components/mixins/E2EMixin';
import { ValidationProvider } from 'vee-validate';
import { PropType } from 'vue';
import { ValidatorProps } from 'types/validator';

export default mixins(E2EMixin).extend({
  components: {
    ValidationProvider,
  },
  name: 'PInput',
  props: {
    type: {
      type: String,
      default: 'text',
      validator: validatorInArray([
        'text',
        'search',
        'email',
        'date',
        'time',
        'password',
        'number',
        'datetime-local',
      ]),
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Object as PropType<ValidatorProps>,
      default: () => ({ name: undefined, rules: undefined }),
    },
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
  },
});
